export default __webpack_public_path__ + "static/media/previousBtn.d4c45e2e.png";